import { styled, Tab, TabProps } from '@mui/material';

export const DialogTab: React.FC<TabProps> = styled(Tab)(({ theme }) => ({
  textTransform: 'none',
  borderBottom: `3px solid ${theme.palette.secondary.main}`,
}));
